import { inject, NgModule } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { WorkflowComponent } from 'src/workflow/workflow.component';

// import { AuthGuardService } from './modules/main/service/authguard.service';
import { PageNotFoundComponent } from './page/error/404/404.component';

import { OrigenceLegalComponent } from 'src/origence-legal/origence-legal.component';
import { AdminLoginComponent } from './page/admin-login/admin-login.component';
import { AdminLogoutComponent } from './page/admin-logout/admin-logout.component';
import { DXLogoutComponent } from './page/dx-logout/dx-logout.component';
import { GenericErrorComponent } from './page/generic_error/generic_error.component';
import { PrefillVerificationComponent } from './page/prefill/prefill-verification.component';
import { RedirectComponent } from './page/redirect/redirect.component';
import { UserVerificationErrorComponent } from './page/user-verification-error/user-verification-error.component';

/** App Routing config */
const AppRouting: Routes = [
  // ⛔ Problem: 'mortgage' defined twice with conflicting redirect targets. This will cause route collision.
  { path: 'mortgage', redirectTo: '/error/404', pathMatch: 'full' },
  { path: 'autoloans', redirectTo: '/error/404', pathMatch: 'full' },
  { path: 'creditcards', redirectTo: '/error/404', pathMatch: 'full' },
  { path: 'tools', redirectTo: '/error/404', pathMatch: 'full' },
  // Dummy component for OAO
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'user/login'
  },
  {
    component: AdminLoginComponent,
    path: 'admin/login'
  },
  {
    component: AdminLogoutComponent,
    path: 'admin/logout'
  },
  {
    component: DXLogoutComponent,
    path: 'user/logout'
  },
  {
    // loadChildren: () => import('../admin/admin.routes').then((m) => m.ecpAdminRoutes),
    loadChildren: () => import('../admin/admin.module').then((m) => m.AdminModule),
    path: 'admin'
  },
  {
    component: RedirectComponent,
    path: 'redirect'
  },
  {
    // loadChildren: () => import('../integration/integration.master.routes').then((m) => m.IntegrationRoutes),
    loadChildren: () => import('../integration/integration.master.module').then((m) => m.IntegrationModule),
    path: 'integration'
  },
  // Dynamic Workflow Widget Route (prefix)
  {
    path: 'app',
    component: WorkflowComponent,
    children: []
  },
  // Dynamic Workflow Widget Redirects
  {
    path: 'heloc',
    pathMatch: 'prefix',
    redirectTo: 'app/heloc'
  },
  {
    path: 'ola',
    pathMatch: 'prefix',
    redirectTo: 'app/ola'
  },
  {
    path: 'ola-consumer',
    pathMatch: 'prefix',
    redirectTo: 'app/ola-consumer'
  },
  {
    // loadChildren: () => import('../postapp/postapp.routes').then((m) => m.postappRoutes),
    loadChildren: () => import('../postapp/postapp.module').then((m) => m.PostappModule),
    path: 'postapp'
  },
  {
    path: 'oao',
    pathMatch: 'prefix',
    redirectTo: 'app/oao'
  },
  // ⛔ Problem: 'mortgage' defined twice with conflicting redirect targets. This will cause route collision.
  {
    path: 'mortgage',
    pathMatch: 'prefix',
    redirectTo: 'app/mortgage'
  },
  {
    // loadChildren: () => import('./modules/main/main.routes').then((m) => m.MainRoutes),
    // canActivate: [AuthGuardService],
    loadChildren: () => import('./modules/main/main.module').then((m) => m.MainModule),
    path: 'consumer'
  },
  {
    // loadChildren: () => import('../user/user.routes').then((m) => m.UserRoutes),
    loadChildren: () => import('../user/user.module').then((m) => m.UserModule),
    path: 'user'
  },
  {
    // loadChildren: () => import('../legal/legal.routes').then((m) => m.LegalRoutes),
    loadChildren: () => import('../legal/legal.module').then((m) => m.LegalModule),
    path: 'legal'
  },
  {
    path: 'terms-and-policy',
    component: OrigenceLegalComponent
  },
  {
    children: [
      {
        component: PageNotFoundComponent,
        path: '404'
      }
    ],
    path: 'error'
  },
  {
    path: 'oops',
    component: GenericErrorComponent,
    // Guard: If APP_INIT succeeded on this page load, the user shouldn't land on /oops.
    // This handles the reload scenario: APP_INIT failed -> /oops -> user refreshes -> APP_INIT succeeds.
    // Redirect them to /error/404 so they don't get stuck on the error page.
    // TODO: Consider extracting this inline guard to a named exported CanActivateFn (e.g. `oopsGuard`)
    // so it can be independently unit-tested without full router setup. Currently no spec covers this logic.
    canActivate: [
      () => {
        if (!(globalThis as Record<string, unknown>).__APP_INIT_ERROR__) {
          return inject(Router).createUrlTree(['/error/404']);
        }
        return true;
      }
    ]
  },
  {
    path: 'contact-us',
    component: UserVerificationErrorComponent
  },
  {
    path: 'prefill/:sessionId/:applicantIndex',
    component: PrefillVerificationComponent
  },
  // ⛔ Problem: This is ambiguous. Only one ** wildcard route should exist, and it must be last. The second will never be reached.
  // TODO: Remove the unreachable second wildcard route — Angular stops matching at the first `**`.
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/error/404'
  },
  { path: '**', pathMatch: 'full', redirectTo: '/oops' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(AppRouting, {
      onSameUrlNavigation: 'reload',
      useHash: false
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
